module.exports = __webpack_public_path__ + "static/media/audio.d26a4f60.png";